import { Api, ArrayUtil, Currency, CurrencySettings, CurrencyUtil, DisplayType } from "@mcleod/core";
import { AutogenLayoutManualOpenItemProcessingPrePostReview } from "./autogen/AutogenLayoutManualOpenItemProcessingPrePostReview";
import { ManualOpenItemProcessingStepperProps } from "./ManualOpenItemProcessingStepper";
import { Label, Panel } from "@mcleod/components";

export class ManualOpenItemProcessingPrePostReview extends AutogenLayoutManualOpenItemProcessingPrePostReview {
    async populateTotalsForReview(props: ManualOpenItemProcessingStepperProps) {
        // While the selectedRows have everything needed to calculate totals, making one API call here
        // avoids multiple calls for currency conversion rates
        const response = await Api.post("lme/ar/get-manual-open-item-totals", { open_items: props.selectedRows });
        const data = response?.data[0];

        const totalAmount = new Currency({ ...data?.total_amount });
        this.mainDataSource.activeRow?.updateCurrency("total_amount", totalAmount);
        this.labelTotalAmount.text = CurrencyUtil.formatCurrency(totalAmount);
        this.mainDataSource.activeRow?.set("open_item_count", data?.open_item_count || 0);
        this.labelOpenItemCount.text = data?.open_item_count || "0";

        if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            this.labelTotalAmountCaption.text = "Net Amount (Functional):";
            const multicurrencyTotals = data?.multicurrency_totals || [];
            this.populateMulticurrencyTotals(multicurrencyTotals);
        }
    }

    populateMulticurrencyTotals(multicurrencyTotals: any[]) {
        this.panelMulticurrencyTotals.removeAll();
        if (!CurrencySettings.getSingleton().multiCurrencyEnabled() || ArrayUtil.isEmptyArray(multicurrencyTotals)) {
            return;
        }

        // Populate the totalsPanel with multicurrency totals
        multicurrencyTotals.forEach(total => {
            const amount = new Currency({ ...total?.amount as Currency });
            const count = total?.count || "0";
            const currencyPanel = new Panel({
                id: "panelCurrencyTotal" + amount.getCurrencyCode(),
                width: 150,
                paddingLeft: 0,
                rowBreak: false
            });

            const currencyTypeCountLabel = new Label({
                id: "labelCurrencyTypeCount" + amount.getCurrencyCode(),
                rowBreak: true,
                text: amount.getCurrencyCode() + ": " + count,
                color: "subtle.darker",
                fontBold: true
            });

            const currencyAmountLabel = new Label({
                id: "labelCurrencyAmount" + amount.getCurrencyCode(),
                rowBreak: true,
                dataSource: this.mainDataSource,
                field: "total_amount_" + amount.getCurrencyCode().toLowerCase(),
                displayType: DisplayType.CURRENCY,
                text: CurrencyUtil.formatCurrency(amount),
                color: "subtle.darker",
                fontBold: true
            });

            currencyPanel.add(currencyTypeCountLabel);
            currencyPanel.add(currencyAmountLabel);
            this.panelMulticurrencyTotals.add(currencyPanel);

            this.mainDataSource.activeRow?.updateCurrency("total_amount_" + amount.getCurrencyCode().toLowerCase(), amount);
        });
    }
}
